<template>
  <div class="d-flex flex-column fv-row" :class="[containerClass]">
      <label class="d-flex align-items-center fs-6 form-label mb-2">
        <span :class="required ? 'required' : ''">{{ label }}</span>
      </label>
      <div id="icons" class="icons-container d-flex">
        <div class="icon-item" v-for="icon in data" :key="icon.value">
          <i :style="[iconContainerIcon, iconItemIcon]" :class="[icon.value, (selectedIcon === icon.value || iconItem === icon.value) ? 'selected' : '']"
            @click="selectIcon(icon.value)"
          ></i>
        </div>
      </div>
   </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue'
import { Theme } from '@/composables/theming';

const emits = defineEmits(['getIcon'])

const props = defineProps({
  label: {
    type: String,
    default: "Label"
  },
  required: Boolean,
  containerClass: String,
  data: {
    type: Array,
    default: () => []
  },
  iconItem: String
})

const selectedIcon = ref(props.iconItem)

const iconContainerIcon = computed(() => {
  const baseStyle = {
    fontSize: '20px',
    cursor: 'pointer',
    color: Theme.gray
  };

  return {...baseStyle}
})

const iconItemIcon = computed(() => {
  const baseStyle = {
    backgroundColor: Theme['gray-200'],
    borderRadius: '5px',
    padding: '10px',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return {...baseStyle}
})

function selectIcon(value) {
  selectedIcon.value = value
  emits('getIcon', value)
}
</script>

<style scoped>
.icons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.icons-container i.selected {
  border: 2px solid rgba(0, 114, 206, 1);
}
</style>
